<div class="flex flex-col flex-grow items-start gap-8">
    <form [formGroup]="form" class="w-full" (ngSubmit)="onSubmit()">
        <div class="flex flex-col gap-4 w-full">
            <div class="w-full">
                <label for="name" class="block mb-2 font-medium text-sm">
                    {{ "contactApartment.contactForm.your" | translate }}
                    {{ "contactApartment.contactForm.name" | translate }}
                    *</label
                >
                <input
                    type="text"
                    id="name"
                    placeholder="{{
                        'contactApartment.contactForm.firstLastName' | translate
                    }}"
                    formControlName="name"
                    class="block p-2.5 border border-neutral-950 focus:border-neutral-700 rounded-md w-full sm:text-sm"
                    autocomplete="name"
                    required
                />
                <span
                    *ngIf="
                        form.get('name')?.hasError('required') &&
                        (form.get('name')?.touched ||
                            formState() === formStateEnum.Invalid)
                    "
                    class="text-red-500 text-sm"
                    >Name {{ "booking.bookingFullForm.isRequired" | translate }}
                </span>
                <span
                    *ngIf="
                        form.get('name')?.hasError('maxlength') &&
                        (form.get('name')?.touched ||
                            formState() === formStateEnum.Invalid)
                    "
                    class="text-red-500 text-sm"
                    >Name {{ "booking.bookingFullForm.isTooLong" | translate }}
                </span>
            </div>
            <div class="w-full">
                <label for="email" class="block mb-2 font-medium text-sm">
                    {{ "contactApartment.contactForm.your" | translate }}
                    E-Mail
                </label>
                <input
                    type="text"
                    id="email"
                    placeholder="Dein E-Mail"
                    formControlName="email"
                    class="block p-2.5 border border-neutral-950 focus:border-neutral-700 rounded-md w-full sm:text-sm"
                    autocomplete="email"
                    required
                />
                <span
                    *ngIf="
                        form.get('email')?.hasError('required') &&
                        (form.get('email')?.touched ||
                            formState() === formStateEnum.Invalid)
                    "
                    class="text-red-500 text-sm"
                >
                    E-Mail
                    {{ "booking.bookingFullForm.isRequired" | translate }}
                </span>
                <span
                    *ngIf="
                        form.get('email')?.hasError('email') &&
                        (form.get('email')?.touched ||
                            formState() === formStateEnum.Invalid)
                    "
                    class="text-red-500 text-sm"
                >
                    E-Mail
                    {{ "booking.bookingFullForm.isInvalid" | translate }}
                </span>
            </div>
            <div>
                <label for="message" class="block mb-2 font-medium text-sm">
                    {{ "contactApartment.contactForm.your" | translate }}
                    {{ "booking.bookingFullForm.message" | translate }}
                </label>
                <textarea
                    type="text"
                    id="message"
                    placeholder="{{
                        'contactApartment.contactForm.writeMessage' | translate
                    }}"
                    formControlName="message"
                    class="block p-2.5 border border-neutral-950 focus:border-neutral-700 rounded-md w-full sm:text-sm"
                    required
                ></textarea>
                <span
                    *ngIf="
                        form.get('message')?.hasError('required') &&
                        (form.get('message')?.touched ||
                            formState() === formStateEnum.Invalid)
                    "
                    class="text-red-500 text-sm"
                >
                    {{ "booking.bookingFullForm.message" | translate }}
                    {{ "booking.bookingFullForm.isRequired" | translate }}
                </span>
                <span
                    *ngIf="
                        form.get('message')?.hasError('minlength') &&
                        (form.get('message')?.touched ||
                            formState() === formStateEnum.Invalid)
                    "
                    class="text-red-500 text-sm"
                >
                    {{ "booking.bookingFullForm.message" | translate }}
                    {{ "booking.bookingFullForm.isTooShort" | translate }}
                </span>
                <span
                    *ngIf="
                        form.get('message')?.hasError('maxlength') &&
                        (form.get('message')?.touched ||
                            formState() === formStateEnum.Invalid)
                    "
                    class="text-red-500 text-sm"
                >
                    {{ "booking.bookingFullForm.message" | translate }}
                    {{ "booking.bookingFullForm.isTooLong" | translate }}
                </span>
            </div>
            <div>
                <div class="flex">
                    <input
                        type="checkbox"
                        id="privacyPolicy"
                        class="disabled:opacity-50 mt-0.5 border-gray-200 rounded focus:ring-blue-500 text-blue-600 disabled:pointer-events-none shrink-0"
                        formControlName="privacyPolicy"
                    />
                    <label
                        for="privacyPolicy"
                        class="ms-3 text-gray-500 text-sm"
                    >
                        {{ "booking.bookingFullForm.agreeTo" | translate }}
                        <a [routerLink]="['datenschutz']" class="underline">
                            {{
                                "booking.bookingFullForm.privacyPolicy"
                                    | translate
                            }}
                        </a>
                    </label>
                </div>
                <span
                    *ngIf="
                        form.get('privacyPolicy')?.hasError('required') &&
                        (form.get('privacyPolicy')?.touched ||
                            formState() === formStateEnum.Invalid)
                    "
                    class="text-red-500 text-sm"
                >
                    {{ "booking.bookingFullForm.privacyPolicy" | translate }}
                    {{ "booking.bookingFullForm.isRequired" | translate }}
                </span>
            </div>
            @switch (formState()) {
                @default {
                    <app-button type="submit" size="small">
                        {{
                            "booking.bookingFullForm.submitRequest" | translate
                        }}
                    </app-button>
                }
                @case (formStateEnum.Submitting) {
                    <div
                        class="inline-block mx-auto mt-3 border-4 border-current border-t-transparent rounded-full size-8 text-primary animate-spin"
                        role="status"
                        aria-label="loading"
                    >
                        <span class="sr-only">Loading...</span>
                    </div>
                }
                @case (formStateEnum.Success) {
                    <h1
                        class="font-semibold text-green-500 text-center ~text-xl/2xl"
                    >
                        {{ data().statusText.successText }}
                    </h1>
                }
                @case (formStateEnum.Error) {
                    <h1
                        class="font-semibold text-red-500 text-center ~text-xl/2xl"
                    >
                        {{ data().statusText.failureText }}
                    </h1>
                }
            }
        </div>
    </form>
</div>
